import React, { useState } from 'react';
import get from 'lodash/get';
import { Typography, TextField, CircularProgress } from '@material-ui/core';
import { sanitizeFieldRestProps, useRecordContext, useRefresh } from "react-admin";
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { customTheme } from '../customTheme';
import config from "../config.json";
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';


export default function RaEditableTextFieldV2(props) {
    const { className, source, emptyText, ...rest } = props;
    const record = useRecordContext(props);
    const value = get(record, source);
    //const notify = useNotify();
    const refresh = useRefresh();

    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);

    const toggleEditMode = () => {
        setEditMode(!editMode);
        setCurrentValue(value);
    };

    const updateField = () => {
        if(currentValue == null || currentValue === "") {
            notify("Please fill the field", "warning");
            return;
        }
        setLoading(true);
        // const params = {
        //     ...record,
        //     [source]: currentValue
        // };
        fetch(`${config.HOST_NAME}/crm/v3/updateControllerParams/${record.device_id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({gate_id : currentValue})
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    notify("Field Updated", "success");
                    toggleEditMode();
                    refresh();
                } else {
                    notify(json.message);
                }
            }).catch((e) => {
                setLoading(false);
                notify('Failed to update the field', 'warning');
            });
    };

    if (editMode) {
        return (<div className="editableTextInput">
            <TextField autoFocus value={currentValue} onChange={event => setCurrentValue(event.target.value)} variant="outlined" size="small" className="MuiTextField-smallInput" style={{ width: 150 }} />
            {loading ?
                <CircularProgress color="primary" size={25} style={{ alignSelf: "center" }} />
                :
                <>
                    <div onClick={updateField} className="iconButton-square" style={{ backgroundColor: customTheme.palette.primary.main + "29" }}><CheckIcon style={{ color: customTheme.palette.primary.main }} /></div>
                    <div onClick={toggleEditMode} className="iconButton-square" style={{ backgroundColor: customTheme.palette.error.main + "29" }}><CloseIcon style={{ color: customTheme.palette.error.main }} /></div>
                </>
            }
        </div>);
    } else {
        return (<div className="editableTextField" onClick={toggleEditMode}>
            <div className="editableTextFieldBackground" />
            <Typography
                component="span"
                variant="body2"
                {...sanitizeFieldRestProps(rest)}
            >
                {(value != null && typeof value !== 'string' ? JSON.stringify(value) : value || emptyText)}
            </Typography>
        </div>);
    }
};